/* eslint-disable @typescript-eslint/no-explicit-any */

import { _FetchConfigData } from './types'

export const _addRequestMiddleware =
  (fetchConfigData: _FetchConfigData) =>
  (mw: _FetchConfigData['requestMiddlewares'][number]) => {
    fetchConfigData.requestMiddlewares.push(mw)
  }
export const _addErrorMiddleware =
  (fetchConfigData: _FetchConfigData) =>
  (mw: _FetchConfigData['errorMiddlewares'][number]) => {
    fetchConfigData.errorMiddlewares.push(mw)
  }
